<template>
  <div v-if="src" class="avatar" :style="{ width: size, height: size }">
    <img :src="src" alt="Profile" class="avatar-img" />
  </div>
  <div
    v-else
    class="avatar avatar-placeholder"
    :style="{ width: size, height: size, backgroundColor: color, fontSize: fontSize }"
  >
    <span class="initials">{{ initials }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  src: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: "User",
  },
  size: {
    type: String,
    default: "35px",
  },
});

// Função para gerar uma cor única com base nas iniciais
const getColorFromInitials = (initials) => {
  let hash = 0;
  for (let i = 0; i < initials.length; i++) {
    hash = initials.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 70%, 70%)`; // Saturação e luminosidade fixas
};

const initials = computed(() => {
  if (props.name) {
    const nameParts = props.name.split(" ").filter((part) => part.length > 0);
    if (nameParts.length > 1) {
      return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
    }
    return nameParts[0][0].toUpperCase();
  }
  return "U";
});

const color = computed(() => getColorFromInitials(initials.value));


const fontSize = computed(() => {
  const numericSize = parseInt(props.size);
  return `${numericSize * 0.4}px`;
});

</script>

<style scoped>
.avatar {
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
  color: #374151;
  font-weight: bold;
  text-transform: uppercase;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>
